import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/statistics/withdrawMoney',
      data
    });
  },
  getAllCoin() {
    return http.get({
      url: '/la/admin/coin/all'
    });
  }
};
